<template>
	<div class="containerbox" style="width: 100%;  padding: 0px;">
		<v-row>
			<v-col md="12" sm="12" lg="12" class="px-10 pb-0">
				<v-card elevation="0" class="containerbox" >
					<div>
						<div style="overflow-y: auto; overflow-x: hidden;" class="px-2">
							<!--Problem Description Section -->
							<v-row v-if="problemDescription" class="pb-5">
								<v-col md="12" sm="12" lg="12" class="pb-0">
									<info-section title="Problem Description" :text="problemDescription" :isPreview="true"
										@view-more="showAllInfo = true" />
								</v-col>
							</v-row>
							<v-divider v-if="problemDescription"></v-divider>

							<!-- Order Notes Section -->
							<v-row v-if="orderNotes" class="pb-5">
								<v-col md="12" sm="12" lg="12" class="pb-0">
									<info-section title="Order Notes" :text="orderNotes" :isPreview="true"
										@view-more="showAllInfo = true" />
								</v-col>
							</v-row>
							<v-divider v-if="orderNotes"></v-divider>

							<!-- Comments Section -->
							<v-template v-if="commentsArray.length > 0" class="ma-0 pa-0 secondary--text">Comments</v-template>
							<br />
							<comment-item v-for="(item, i) in (showAll ? commentsArray : commentsArray.slice(0, 1))" :key="i"
								:item="item">
								<template v-slot:actions>
									<a v-if="commentsArray.length > 1" class="f-11 f-bold" @click="showCommentDetails"
										v-bind:class="($vuetify.theme.dark) ? 'anchorDark' : 'anchorlight'"> View More</a>
								</template>
							</comment-item>
						</div>
					</div>
				</v-card>
			</v-col>
		</v-row>
		<!-- Show all dialog -->
		<v-row>
			<v-col sm="11" md="11" lg="11">
				<v-dialog v-model="showAllInfo" width="80%" persistent class="containerbox">
					<v-card>
						<v-card-title class="subtitle-2 primary customwhite--text d-flex align-center">
							<span>Show All Information</span>
							<v-spacer></v-spacer>
							<v-btn outlined class="pa-0 mx-2" dense small title="Close" color="customwhite"
								@click="showAllInfo = false">
								<v-icon small>mdi-close</v-icon>
							</v-btn>

						</v-card-title>

						<v-card-text class="py-2">
							<v-container fluid class="pa-0 py-2">
								<!-- Problem Description Section -->
								<template v-if="problemDescription">
									<info-section title="Problem Description" :text="problemDescription" :isPreview="false" />
									<v-divider></v-divider>
								</template>

								<!-- Order Notes Section -->
								<div v-if="orderNotes" class="pt-3">
								<template >
									<info-section title="Order Notes" :text="orderNotes" :isPreview="false" />
									<v-divider></v-divider>
								</template>
								</div>

								<!-- Comments Section -->
								<div v-if="commentsArray.length>0" class="pt-3 dialog-comments-section">
									<v-template class="secondary--text">Comments</v-template>
									<comment-item v-for="(item, i) in commentsArray" :key="i" :item="item" />
								</div>
							</v-container>
						</v-card-text>

						<v-card-actions class="justify-center pa-4">
							<v-btn outlined color="secondary" cl @click="showAllInfo = false">Close</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
		</v-row>
		<v-row>
		</v-row>
	</div>
</template>

<script>
import utility from '@/shared/utility';
import commonApiService from './js/common-api-service';
import CommentItem from './comment-item.vue';
import InfoSection from './info-section.vue';

export default {
	name: 'CommonCommentDisplay',
	props: {
		commentsObj:Object,
		commentsData:Object
	},
	data() {
		return {
			commentsArray: [],
			showAll: false, // State to toggle between showing all or one comment
			orderNotes: "",
			problemDescription: "",
			showAllInfo: false,
		};
	},

	mounted() {
		if(this.commentsData){
			this.problemDescription=this.commentsData?.NotesInfo[0]?.prob_desc;
			this.orderNotes=this.commentsData?.NotesInfo[0]?.notes;
			this.commentsArray=this.commentsData?.CommentsInfo;
			this.commentArrayModification();
		}else{
		this.getCommentList();
		}
	},

	components: {
		CommentItem,
		InfoSection,
	},

	methods: {
		async getCommentList() {
			let commentData = await commonApiService.postOrderComments("post", this.commentsObj, false);
			let commentList = commentData?.NotesCommentsDetails;
			this.commentsArray = commentList?.CommentsInfo;
			this.commentArrayModification();
			this.problemDescription = commentData?.NotesCommentsDetails.NotesInfo[0].prob_desc
			this.orderNotes=commentData?.NotesCommentsDetails.NotesInfo[0].notes
		},
		toggleShowAll() {
			this.showAll = !this.showAll;
		},
		commentArrayModification() {
			if(!this.commentsArray) return;
			this.commentsArray?.forEach((element) => {
				element.date = utility.displayDateFormat(element.modified_date);
			});
		},
		// Add this method to handle comment view more click
		showCommentDetails() {
			this.showAllInfo = true;
			this.$nextTick(() => {
				// Wait for dialog to render and then scroll to comments section
				setTimeout(() => {
					const commentsSection = document.querySelector('.dialog-comments-section');
					if (commentsSection) {
						commentsSection.scrollIntoView({ behavior: 'smooth' });
					}
				}, 100);
			});
		}
	},

};
</script>

<style>

</style>